'use client'

import { ProductSlider } from '@/feature/product/components/product-slider/ProductSlider.client'
import { filterAvailableProducts } from '@/feature/product/services/product.filtering'
import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import { useIsAuthenticated } from '@/lib/auth/client/AuthProvider.client'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { useNextIsClientHydrated } from '@/lib/next/useNextIsClientHydrated'
import { Section } from '@/ui/layouts/section/Section'
import { Loader } from '@/ui/loaders/loader/Loader'
import { useQuery } from '@apollo/client'
import { gql } from '@gql-generated/gql'
import { GetAlsoBoughtSliderDocument } from '@gql-generated/graphql'

export const GET_ALSO_BOUGHT_SLIDER_QUERY = gql(/* GraphQL */ `
  query GetAlsoBoughtSlider($urlKey: String!) {
    product(urlKey: $urlKey) {
      reference
      recommendedProducts {
        ...ProductCard
      }
    }
  }
`)

type AlsoBoughtSliderProps = {
  slug: string
}

export function AlsoBoughtSlider({ slug }: AlsoBoughtSliderProps): React.ReactElement | null {
  const { t } = useTranslation(['alsoBoughtSlider'])
  const isMounted = useNextIsClientHydrated()
  const isAuthenticated = useIsAuthenticated()
  const { data, loading } = useQuery(GetAlsoBoughtSliderDocument, {
    ...APOLLO_CLIENT_SIDE_OPTIONS,
    variables: {
      urlKey: slug,
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-only',
  })

  const alsoBoughtProducts = filterAvailableProducts(data?.product?.recommendedProducts ?? [])

  if (!isMounted || !isAuthenticated || (!loading && !alsoBoughtProducts.length)) {
    return null
  }

  return (
    <>
      {loading ? (
        <div className="flex justify-center py-2">
          <Loader />
        </div>
      ) : (
        <Section title={t('alsoBoughtSlider:title')}>
          <ProductSlider products={alsoBoughtProducts} source="nos clients ont également acheté" />
        </Section>
      )}
    </>
  )
}
